var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessIco3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4MLdkOoqw91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 127.965 127.965",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 127.965,
    height: 127.965,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M615.937581,315.005294c0,173.982206-137.871372,314.99545-307.963978,314.990529C137.871372,630.000744,0,488.9875,0,315.005294C-0.008421,141.023088,137.871372,0,307.973603,0C478.066209,0,615.937581,141.02801,615.937581,315.005294Z",
    transform: "matrix(.102963-.104774 0.102436 0.100665 0 59.812553)",
    fill: "#9ed368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512,256.005c0-21.556-2.695-42.478-7.712-62.478-.109-.105-.21-.217-.32-.32-.541-.576-91.175-91.212-91.751-91.751-6.811-7.254-16.413-11.856-27.124-11.856h-258.185c-20.571,0-37.308,16.737-37.308,37.307v258.186c0,10.709,4.599,20.309,11.852,27.12.541.577,91.179,91.214,91.756,91.756.105.112.218.213.323.323c19.998,5.015,40.918,7.71,62.473,7.709C397.394,512.004,512,397.401,512,256.005Z",
    transform: "matrix(.149477 0 0 0.149679 29.288484 23.889875)",
    fill: "#8bc052"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.148131 0 0 0.142125 26.612903 22.870564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.092,89.6h-258.184c-20.571,0-37.308,16.737-37.308,37.308v258.186c0,20.57,16.737,37.307,37.308,37.307h258.186c20.57,0,37.307-16.737,37.307-37.308v-258.185C422.4,106.337,405.663,89.6,385.092,89.6Zm23.441,295.492c0,12.926-10.515,23.441-23.441,23.441h-258.184c-12.926,0-23.441-10.515-23.441-23.441v-258.184c0-12.926,10.515-23.441,23.441-23.441h258.186c12.925,0,23.44,10.515,23.44,23.441v258.184Z",
    fill: "#f4f6f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.97,186.667L186.667,325.334h17.991l12.973-42.998h44.346l13.388,42.998h18.407L250.68,186.667h-20.71Zm-8.995,82.085l11.924-38.678c2.513-8.64,4.604-18.103,6.483-26.951h.634c1.879,8.64,3.97,17.903,6.694,27.158l12.128,38.471h-37.863Z",
    fill: "#f4f6f9"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.569,
    height: 140.584,
    rx: 0,
    ry: 0,
    transform: "translate(312.811 185.749)",
    fill: "#f4f6f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIco3);
export default __webpack_public_path__ + "static/media/process_ico_3.893c4dfb68f5c1c6cf7a878d11cdbe5f.svg";
export { ForwardRef as ReactComponent };